<template>
  <div>
    <b-row :style="{marginBottom: '18px'}">
      <b-col sm="9">
        <b-form-select v-model="selectedUser" :options="userOptions" />
      </b-col>
      <b-col sm="3">
        <b-button class="float-right" variant="outline-primary" @click="exportUser"><i class="fa fa-download" /> 导出</b-button>
      </b-col>
    </b-row>
    <b-table class="text-center" show-empty responsive="sm" :items="items" :fields="fields" :emptyText="tableEmptyText">
      <template #cell(user_name)="data">
        <span>{{ data.item.user_name }}({{ userLoginTypes[data.item.login_typ] }})</span>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      prev-text="<<"
      next-text=">>"
      @change="changePage"
      hide-goto-end-buttons
      first-number
      last-number
    />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'user',
  mixins: [Error],
  props: ['appId', 'oversea'],
  data () {
    return {
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      items: null,
      fields: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      userOptions: [],
      selectedUser: '',
      userLoginTypes: consts.VOTE_USER_LOGIN_TYPES,
      separate: '__ZsFgf__',
      baseTabName: '用户投票统计',
      tabName: '用户投票统计(所有用户)'
    }
  },
  created () {
    this.getVoteUserList()
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      this.getLogList()
    },
    getVoteUserList () {
      api.fetchVoteListData(this, api.getVoteStatisticsUserList(), 'user_list', {app_id: this.appId}, this.oversea ? consts.OVERSEA_TYPE : '', this.handleUserList)
    },
    handleUserList (resData) {
      let userOptions = [
        {text: '所有用户', value: ''}
      ]
      for (let idx in resData['user_list']) {
        let item = resData['user_list'][idx]
        let val = item.user_name + this.separate + item.login_typ.toString()
        userOptions.push({text: item.user_name + '(' + this.userLoginTypes[item.login_typ] + ')', value: val})
      }
      this.userOptions = userOptions
      this.getLogList()
    },
    handleLogList (resData) {
      this.items = resData['log_list']
      this.totalRows = resData.total_num
    },
    getLogList () {
      let userInfo = this.getUserInfo(this.selectedUser)
      api.fetchVoteListData(this, api.getVoteUserStatistics(), 'log_list', {app_id: this.appId, username: userInfo.username, login_typ: userInfo.loginType}, this.oversea ? consts.OVERSEA_TYPE : '', this.handleLogList)
      this.fields = this.selectedUser ? consts.VOTE_USER_SINGLE_FIELDS : consts.VOTE_USER_ALL_FIELDS
    },
    exportUser () {
      let userInfo = this.getUserInfo(this.selectedUser)
      this.$emit('export', {
        path: api.getVoteUserStatisticsExport(),
        username: userInfo.username,
        login_typ: userInfo.loginType,
        tab: this.tabName
      })
    },
    getUserInfo (val) {
      let username = ''
      let loginType = ''
      if (val) {
        username = val.split(this.separate)[0]
        loginType = val.split(this.separate)[1]
      }
      return {
        username: username,
        loginType: loginType
      }
    }
  },
  watch: {
    selectedUser (val) {
      let userInfo = this.getUserInfo(val)
      if (userInfo.username) {
        this.tabName = this.baseTabName + '(' + userInfo.username + '-' + this.userLoginTypes[Number(userInfo.loginType)] + ')'
      } else {
        this.tabName = this.baseTabName + '(所有用户)'
      }
      this.getLogList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// User.vue?5daeae20